const LocalInstancesListRecipie = {
    $type$: 'Recipe',
    name: 'LocalInstancesList',
    rule: [
        {
            itemprop: 'id',
            itemtype: { type: 'string', regexp: /^LocalInstancesList$/ },
            isId: true
        },
        {
            itemprop: 'instances',
            itemtype: {
                type: 'array',
                item: {
                    type: 'object',
                    rules: [
                        {
                            itemprop: 'instance',
                            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Instance']) }
                        }
                    ]
                }
            }
        }
    ]
};
const InstancesRecipes = [LocalInstancesListRecipie];
export default InstancesRecipes;
//# sourceMappingURL=InstancesRecipies.js.map